export var getIsOpenAfterChange = function getIsOpenAfterChange(key) {
  return ['ArrowDown', 'ArrowUp'].includes(key) ? true : false;
};